import './RecordContainer.scss';
import { Card } from 'antd';
import classNames from 'classnames';
import { ifClickHandler } from '@lib/events';
import React, { PropsWithChildren, useMemo } from 'react';

export interface SonarRecordContainerProps {
	className?: string;
	onClick?: () => void;
}

export const SonarRecordContainer: React.FC<PropsWithChildren<SonarRecordContainerProps>> = ({
	children,
	className,
	onClick
}) => {
	const classes = classNames('animate sonar-record', className, {
		clickable: onClick
	});

	const handleOnClick = useMemo(() => ifClickHandler(onClick), [ onClick ]);

	return (
		<Card
			className={ classes }
			onClick={ handleOnClick }>
			{ children }
		</Card>
	);
};
